import React, { Component } from 'react';
import './Ritirocard.css';
import dvrc from '../../images/public/registeration/dvrc.png';
import clos from '../../images/public/registeration/clos.png';
import { element } from 'prop-types';
import classNames from 'classnames';
import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';
import { Rectangle, Circle, Ellipse, Line, Polyline, CornerBox, Triangle } from 'react-shapes';
import { RadioGroup, Radio } from 'react-radio-group';
import { height } from 'window-size';
import WebFont from 'webfontloader';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
import Riepicarrello from '../Riepicarrello/Riepicarrello';
import Indirizione from '../Indirizione/Indirizione';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
import RadioVerTwo from '../../assets/components/radiobtn/RadioVerTwo'
import { addToCart, buyAnotherCard, getServicePrice } from '../../libs/fetch'
import WaitLoad from "../../assets/components/loading/WaitLoad";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

class Ritirocard extends Component {
    constructor(props) {
        super(props);

        let params = null;
        console.log('[Ritirocard]', params);

        this.state = {
            loadedData: false,
            isLoading: false,

            errmsg: null,
            errorFlg: false,

            purchaseCart: [],

            isSecondCard: false,
            deliveryPointForScondCard: "0",
            purchaseHere: false,

            shipmentPrices: '',
        };
    }
    componentDidMount() {
        let purchaseCart = JSON.parse(localStorage.getItem("purchaseCart"));
        let linkedUser = JSON.parse(localStorage.getItem('linkedUser'));
        let cart = JSON.parse(localStorage.getItem("cart"));
        if (linkedUser) {
            this.setState({ isSecondCard: true });
        }
        console.log('[Ritirocard] @purchaseCart: ', purchaseCart);
        this.setState({ purchaseCart, linkedUser, cart });
        this.forceUpdate(() => {
            this.setState({ loadedData: true });
            this.setDeliveryPoint("0");

        })

        //get delivery price to show as notice 
        this.getDeliveryPrice();
    }



        //get delivery price to show as notice 
        getDeliveryPrice = () => {
            let access_token = cookies.get('access_token');
            let params = {
                service: "sci",
                portal: 'sci',//neede for getServiceDescription
                type: 'shipment'
            };

            getServicePrice(this, access_token, params)
                .then((response) => {
                    console.log("[Ritirocard] getServicePrice @response: ", response);
                    if (response == "fail" || response < 0) {
                      console.log("[Ritirocard] getServicePrice error");
                      this.setState({
                            errorFlg: true,
                            errmsg: response.message
                        });
                    } else {
                        //success case!
                        console.log("[Ritirocard] getServicePrice success");
                        this.setState({ shipmentPrices: tr.t('shippingCost')+' '+formatter.format(response) })
                      }
                });
        }

    //set delivery point by default to first option at the componentDidMount and change by user action
    setDeliveryPoint = (point) => {
        let purchaseCart = this.state.purchaseCart;
        if (purchaseCart && purchaseCart.length > 0) {
            purchaseCart[purchaseCart.length - 1].shipment = point;
        }
        return this.setState({ purchaseCart, deliveryPointForScondCard: point });
    }

    gotoAddToCart = (e) => {
        e.preventDefault();
        if (this.state.isSecondCard) {
            //here we don't need to check checkIfCanBuyCard
            return this.buyAnotherCard();
        }

        console.log("[Ritirocard] gotoAddToCart");
        this.forceUpdate(() => {
            localStorage.setItem("purchaseCart", JSON.stringify(this.state.purchaseCart));
            return this.addToCart();
        })
    }

    RadioVerTwoCB(info) {
        console.log("[Ritirocard] RadioVerTwoCB:  ", info);
        this.setDeliveryPoint(info);
    }

    //this call is used to add new Card into the purchase cart
    addToCart = () => {
        this.forceUpdate(() => {
            let purchaseCart = this.state.purchaseCart;
            let params = {};
            let joint_number_of_services_adult = "";
            let joint_number_of_services_reduced = "";
            let joint_code = "";
            let joint_type = "";
            let joint_provider = "";
            let joint_shipment = "";
            let joint_name = "";
            let joint_surname = "";
            let joint_date_of_birth = "";
            let joint_gender = "";
            //concatenating same parameters 
            for (var i in purchaseCart) {
                // joint_number_of_services_adult += (i > 0 ? "," : "") + purchaseCart[i].number_of_services_adult;
                // joint_number_of_services_reduced += (i > 0 ? "," : "") + purchaseCart[i].number_of_services_reduced;
                joint_number_of_services_adult = purchaseCart[i].number_of_services_adult;//we need only the latest number
                joint_number_of_services_reduced = purchaseCart[i].number_of_services_reduced;//we need only the latest number
                joint_code += (i > 0 ? "," : "") + purchaseCart[i].code;
                joint_type += (i > 0 ? "," : "") + purchaseCart[i].type;
                joint_provider += (i > 0 ? "," : "") + purchaseCart[i].provider;
                joint_shipment += (i > 0 ? "," : "") + purchaseCart[i].shipment;
                joint_name += (i > 0 ? "," : "") + purchaseCart[i].name;
                joint_surname += (i > 0 ? "," : "") + purchaseCart[i].surname;
                joint_date_of_birth += (i > 0 ? "," : "") + purchaseCart[i].date_of_birth;
                joint_gender += (i > 0 ? "," : "") + purchaseCart[i].gender;
            }
            params = {
                number_of_services_adult: joint_number_of_services_adult,
                number_of_services_reduced: joint_number_of_services_reduced,
                code: joint_code,
                type: joint_type,
                provider: joint_provider,
                shipment: joint_shipment,
                name: joint_name,
                surname: joint_surname,
                date_of_birth: joint_date_of_birth,
                gender: joint_gender,
            }
            console.log('[Ritirocard] addToCart @purchaseCart: ', purchaseCart);
            console.log('[Ritirocard] addToCart @params: ', params);
            let access_token = cookies.get('access_token');
            addToCart(this, access_token, params)
                .then((response) => {
                    console.log("[Ritirocard] addToCart @response: ", response);
                    if (response.status == "success") {
                        return this.props.history.push('/Riepicarrello');
                    } else {
                        this.setState({
                            errorFlg: true,
                            errmsg: response.message
                        });
                    }
                });
            return
        })
    }



    //this call is used for purchasing second card for the same user
    buyAnotherCard = () => {
        this.setState({ isLoading: true });
        let linkedUser = this.state.linkedUser;
        if (this.state.deliveryPointForScondCard == "1") {
            //user want to receive the card at his address..
            return this.props.history.push('/Indirizione');
        } else {
            //user want to receive the card at Ski resort...
            let access_token = cookies.get('access_token');
            let params = {
                linked_user_id: linkedUser.id,
                provider: linkedUser.provider.toLowerCase() == "skidata" ? "axess" : "skidata",
                // type: linkedUser.type, //According to @Veronica type should be changed to on of new, renew, second_card
                type: 'second_card',
                code: this.state.cart.cardNumber,
                shipment: '0',//1 for card to be shipped,otherwise 0
            };
            buyAnotherCard(this, access_token, params)
                .then((response) => {
                    this.setState({ isLoading: false });
                    console.log("[Ritirocard] buyAnotherCard @response: ", response);
                    if (response.status == "success") {
                        return this.props.history.push('/');
                    } else {
                        this.setState({
                            errorFlg: true,
                            errmsg: response.message
                        });
                    }
                });
        }
    }

    alertResponse(info) {
        switch (info.type) {
            case "closeButton":
                this.setState({ errorFlg: false })
                break;
            case "actionButton":
                if (info.option1 == "attention") {
                    this.setState({ errorFlg: false })
                    break;
                }
        }
    }

    render() {
        console.log('[Ritirocard]', this.state);
        return (
            <Router>
                <div>
                    <div>
                        <BrowserView>
                            <div className="containermbcgrb">
                                {tr.userlng() == 'IT' && <div className="navri"></div>}
                                {tr.userlng() != 'IT' && <div className="navre"></div>}
                                <div className="containermrb">
                                    <div className="closr">
                                        <a onClick={() => { return this.props.history.push('/') }}><img src={clos} className="rspn" /></a>
                                    </div>
                                    <div className="dvrc">
                                        {tr.t("Wheretoreceive")}
                                    </div>
                                    {/* {this.state.errorFlg && <div className="warnr">{this.state.errmsg}</div>} */}
                                    <div className="containersrb">
                                        <form>
                                            <RadioVerTwo context01={tr.t("Withdraw")} context02={tr.t("Ship")} context02details={this.state.shipmentPrices} callback={this.RadioVerTwoCB.bind(this)} />
                                        </form>
                                    </div>
                                    <div className="containerbrb">
                                        <form>
                                            <button className="drbtn" onClick={this.gotoAddToCart}>{((this.state.deliveryPointForScondCard == "0") && this.state.isSecondCard) ? tr.t("Purchase") : tr.t("Next")}</button>
                                        </form>
                                    </div>
                                    <div className="marginBottomr"></div>
                                </div>
                            </div>
                        </BrowserView>
                        <MobileView>
                            <div className="containermbcgrm">
                                <div className="navrm"></div>
                                <div className={(isMobileOnly || isAndroid) ? "containermrm" : "containermrt"}>
                                    <div className="closrm">
                                        <a href="https://www.mypass.ski/"><img src={clos} className="rspn" /></a>
                                    </div>
                                    <div className="dvrcm">
                                        {tr.t("Wheretoreceive")}
                                    </div>
                                    {/* {this.state.errorFlg && <div className="warnrm">{this.state.errmsg}</div>} */}
                                    <div className={(isMobileOnly || isAndroid) ? "containersrm" : "containersrt"}>
                                        <form>
                                            <RadioVerTwo mobileFont={true} context01={tr.t("Withdraw")} context02={tr.t("Ship")} context02details={this.state.shipmentPrices} callback={this.RadioVerTwoCB.bind(this)} />
                                        </form>
                                    </div>
                                    <div className={(isMobileOnly || isAndroid) ? "containerbrm" : "containerbrt"}>
                                        <form>
                                            <button className="drbtnm" onClick={this.gotoAddToCart}>{((this.state.deliveryPointForScondCard == "0") && this.state.isSecondCard) ? tr.t("Purchase") : tr.t("Next")}</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </MobileView>
                        {this.state.errorFlg ?
                            <div className="containerModal">
                                {this.state.errorFlg ?
                                    <AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.errmsg} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
                                }
                            </div> : null
                        }
                    </div>
                    <WaitLoad enable={this.state.isLoading} />
                </div>
            </Router>
        );
    }
}
var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
});
export default Ritirocard;


// WEBPACK FOOTER //
// ./src/screens/Ritirocard/Ritirocard.js